// extracted by mini-css-extract-plugin
module.exports =  {"tc-skip-links":"SkipLinks-module__tc-skip-links___u66dx","icon":"SkipLinks-module__icon___xpkSi","text":"SkipLinks-module__text___iSlLs"};